import styles from './preview-banner.component.module.less';

const PreviewBannerComponent = () => (
  <div className={styles['preview-banner']}>
    <span>You&apos;re seeing a preview page</span>
  </div>
);
export default PreviewBannerComponent;
